module.exports = __webpack_public_path__ + "img/icon_im_Facebook.9bca70d3.webp";